import { Suspense } from "react";

import { PageSkeleton } from "@stacklet/ui";
import { lazily } from "react-lazily";

import { lazyRouteLoader } from "app/utils/lazyRouteLoader";

import type { PreloadingRouteProps } from "app/utils/lazyRouteLoader";

// Routes.tsx imports this module statically, so it is part of the app shell's
// bundle: the page and its preload module may only be imported dynamically
// here, or the split that lets the loader run ahead of the page's chunk is
// lost.

const { PolicyDetailsRoute } = lazily(() => import("./PolicyDetailsRoot"));

/**
 * The policy details routes, with and without a version in the URL: see
 * PolicyDetailsRoot.
 */
export const policyDetailsRoute: PreloadingRouteProps = {
  element: (
    <Suspense fallback={<PageSkeleton />}>
      <PolicyDetailsRoute />
    </Suspense>
  ),
  loader: lazyRouteLoader({
    load: () =>
      import("./policyDetailsPreload").then((module) =>
        module.createPolicyDetailsLoader(),
      ),
    warm: () => import("./PolicyDetailsRoot"),
  }),
  // The details page keeps its own query up to date while it is mounted (see
  // useRoutePreloadedQuery), so the loader only runs again when the URL names
  // a different policy — not for the tab, filter and sort changes that also
  // write to the URL, which the page and its tables handle themselves.
  shouldRevalidate: ({ currentParams, nextParams }) =>
    currentParams.policyUUID !== nextParams.policyUUID ||
    currentParams.versionNumber !== nextParams.versionNumber,
};
